import { usePageEditorContext } from '../../contexts/page-editor.context'
import { ImageBlock } from '../../blocks/image/image-block'

import { useStyles } from './image-block-edit-inline.style'

export const ImageBlockEditInline = function ({ block }) {
  const classes = useStyles()

  block.props = block.props || {}

  const pageEditorContext = usePageEditorContext() || {}
  const currentEdit = pageEditorContext.currentEdit || {}

  return <>
    <div className={classes.preview}>
      {currentEdit.imagePreviewUrl
        ? <img src={currentEdit.imagePreviewUrl} className={classes.image} data-qa="image-block"/>
        : (block.props && (block.props.imageVersion || block.props.source))
          ? <ImageBlock blockKey={block.key} report={pageEditorContext.page} {...block.props} />
          : <div className={classes.instructions}>Upload an image from the sidebar</div>
      }
    </div>
  </>
}
